var _style, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAsktug = function SvgAsktug(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "asktug_svg__\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 56 56",
    style: {
      enableBackground: "new 0 0 56 56"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".asktug_svg__st0{fill:#e8eaf1}")), /*#__PURE__*/React.createElement("g", {
    id: "asktug_svg__\\u7EC4_5976",
    transform: "translate(-309 -520)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "asktug_svg__\\u7EC4_5497",
    transform: "translate(321 528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "asktug_svg__\\u7EC4_5257"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "asktug_svg__\\u8DEF\\u5F84_15814",
    className: "asktug_svg__st0",
    d: "M29.4 19.6c4.2-5.1 3.5-12.6-1.5-16.8-4.8-4-11.9-3.6-16.2.8l-8.1 8.1 3 3L8.3 13c.6 6.1 5.7 10.9 11.9 10.9h.2l-.2 5L28 21c.5-.4.9-.8 1.3-1.3l.1-.1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "asktug_svg__\\u8DEF\\u5F84_15815",
    d: "M28 16.1c0-6.6-5.3-11.9-11.9-11.9-3.2 0-6.3 1.3-8.6 3.6l-3.9 4 1 1c-1.8 6.3 1.8 12.9 8.2 14.8 2.5.7 5.1.6 7.5-.3v1.5l3.9-3.9c2.4-2.3 3.8-5.5 3.8-8.8z",
    style: {
      fill: "#be1d32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "asktug_svg__\\u8DEF\\u5F84_15816",
    d: "M23.9 20.2c0-6.6-5.3-11.9-11.9-11.9S0 13.6 0 20.2c0 5.5 3.7 10.2 9 11.6V40l10.8-10.8c2.6-2.2 4.1-5.5 4.1-9z",
    style: {
      fill: "#172d72"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "asktug_svg__\\u7EC4_5256",
    transform: "translate(5.65 12.967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "asktug_svg__\\u8DEF\\u5F84_15817",
    className: "asktug_svg__st0",
    d: "M6.3 0 0 3.6v3.6l3.1-1.8v7.3l3.1 1.8V3.6l3.1-1.8-3-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "asktug_svg__\\u8DEF\\u5F84_15818",
    className: "asktug_svg__st0",
    d: "M9.4 5.4v7.3l3.1-1.8V3.6L9.4 5.4z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "asktug_svg__\\u7EC4_5963",
    transform: "translate(309 520)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "asktug_svg__\\u77E9\\u5F62_5289",
    style: {
      fill: "none"
    },
    d: "M0 0h56v56H0z"
  }))));
};
export default SvgAsktug;